import PropTracker from "../../../../prop-trackers/prop-tracker.js";
import Zipper from "../../../../prop-tracker-utils/zipper.js";

class SkeletonTrackerAssigner {
    constructor(assigner) {
        this._assigner = assigner;

        this._objectTracker = new PropTracker();
        this._skeletonTracker = new PropTracker();

        this._zipper = new Zipper();
        this._zipper.setSource("object", this._objectTracker);
        this._zipper.setSource("skeleton", this._skeletonTracker);
    }

    trackObjects(objects, objectEvents) {
        this._objectTracker.track(objects, objectEvents);
    }

    trackSkeletons(skeletons, skeletonEvents) {
        this._skeletonTracker.track(skeletons, skeletonEvents);
    }

    update() {
        this._zipper.update(({ trackers }) => {
            for (const tracker of trackers) {
                tracker.update(({ userdata: key, props }) => {
                    const { oldValue: oldObject, newValue: newObject } = props.get("object");
                    const { oldValue: oldSkeleton, newValue: newSkeleton } = props.get("skeleton");

                    if (oldObject && oldSkeleton) {
                        this._assigner.unlink(oldObject, oldSkeleton);
                    }

                    if (newObject && newSkeleton) {
                        this._assigner.link(newObject, newSkeleton);
                    }
                });
            }
        });
    }
}

export default SkeletonTrackerAssigner;
